if (!customElements.get("footer-details")) {
  class FooterDetails extends AccordionDetails {
    constructor() {
      super();
    }
    
    connectedCallback() {
      this.openDefault = this.dataset.openDefault === 'true';

      if (FoxTheme.config.mqlTablet) {
        if (!this.openDefault) this.open = false;
      }

      document.addEventListener('matchTablet', () => {
        if (!this.openDefault) {
          this.open = false;
        } else {
          this.open = true;
        }
      });

      document.addEventListener('unmatchTablet', () => {
        this.open = true;
      });
    }
  }
  customElements.define('footer-details', FooterDetails, { extends: 'details' });
}
// Force "Buy it now" -> "BLI DIREKT"
(function () {
  const replaceBuyItNow = () => {
    document
      .querySelectorAll('.shopify-payment-button__button')
      .forEach(btn => {
        const text = btn.innerText?.trim().toLowerCase();
        if (text === 'buy it now' || text === 'buy now') {
          btn.innerText = 'BLI DIREKT';
        }
      });
  };

  // Run on load
  document.addEventListener('DOMContentLoaded', replaceBuyItNow);

  // Observe DOM changes (Shopify re-renders dynamic button)
  const observer = new MutationObserver(() => {
    replaceBuyItNow();
  });

  observer.observe(document.body, {
    childList: true,
    subtree: true
  });
})();
